import React, {useState, useEffect} from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useHistory,
} from 'react-router-dom';
import PrivateRoute from './components/privateRoute/PrivateRoute';
import {AuthContext} from './contexts/AuthContext';
import {UserContext} from './contexts/UserContext';
import {DepartmentContext} from './contexts/DepartmentContext';
import {
  getCurrentUser,
  getDepartmentsCurrentUser,
} from './services/accountService';
import Login from './app/login/Login';
import Dashboard from './app/dashboard/Dashboard';
import Users from './app/administration/users/Users';
import FinancialPerformances from './app/administration/FinancialPerformances/FinancialPerformances';
import Departments from './app/administration/department/Departments';
import RiskCategories from './app/administration/RiskCategories/RiskCategories';
import RiskCauses from './app/administration/RiskCauses/RiskCauses';
import CourtSubcategoryRisks from './app/administration/CourtSubcategoryRisks/CourtSubcategoryRisks';
import Processes from './app/administration/Processes/Processes';
import Subprocesses from './app/administration/Subprocesses/Subprocesses';
import FrequencyOccurenceRisks from './app/administration/FrequencyOccurenceRisks/FrequencyOccurenceRisks';
import TypeGainLoss from './app/administration/TypeGainLoss/TypeGainLoss';
import CourtCategoryRisks from './app/administration/CourtCategoryRisks/CourtCategoryRisks';
import BusinessLines from './app/administration/BusinessLines/BusinessLines';
import Metodologies from './app/administration/Metodologies/Metodologies';
import AddIncurredRisk from './app/IncurredRisk/AddIncurredRisk';
import CostEstimations from './app/administration/CostEstimations/CostEstimations';
import PotentialRiskTypes from './app/administration/PotentialRiskTypes/PotentialRiskTypes';
import MitigationRisk from './app/administration/MitigationRisk/MititgationRisk';
import DepartmentType from './app/administration/DepartmentType/DepartmentType';
import KeyRiskIndicators from './app/keyRiskIndicators/KeyRiskIndicators';
import {getLanguage} from 'react-switch-lang';
import KriReport from './app/reports/KRIReport';
import KriReport2 from './app/reports/KRIReport2';
import LitigationReport from './app/reports/LitigationReport';
import OccurredRiskReport from './app/reports/OccurredRiskReport';
import RiskLossReport from './app/reports/RiskLossReport';
import AddKeyRiskIndicator from './app/keyRiskIndicators/addKeyRiskIndicator/AddKeyRiskIndicator';
import ViewKeyRiskIndicator from './app/keyRiskIndicators/viewKeyRiskIndicator/ViewKeyRiskIndicator';
import Revisions from './app/revisions/Revisions';
import Risks from './app/Risks/AllRisks';
import EnteredRisks from './app/enteredRisks/EnteredRisks';
import VerifiedRisks from './app/verifiedRisks/VerifiedRisks';
import DuringRisks from './app/duringRisks/DuringRisks';
import ClosedRisks from './app/closedRisks/ClosedRisks';
import RejectedRisks from './app/rejectedRisks/RejectedRisks';
import ErrorPage404 from './app/errorPages/404';
import ErrorPage403 from './app/errorPages/403';
import RiskComponents from './app/RiskComponents/RiskComponents';
import Measures from './app/reports/MeasuresReport';
import roles from './utils/roles';
import 'antd/es/spin/style/css';
import ORNewProductsProcesses from './app/reports/ORNewProductsProcesses';
import {Spin} from 'antd';
import 'antd/dist/antd.css';
import AddPotentialRisk from './app/potentialRisk/AddPotentialRisk/AddPotentialRisk';
import AddLitigation from './app/litigation/AddLitigation/AddLitigation';
import ThirdPartiesReport from './app/reports/ThirdPartiesReport';
import SubRisksCauses from './app/administration/SubRisksCauses/SubRisksCauses';
import DeletedRisks from './app/deletedRisk/DeletedRisk';
import ReportLog from './app/reports/ReportLog';

import RevisionType from './app/administration/revisionTypes/RevisionType';
import RevisionScope from './app/administration/revisionScope/RevisionScope';

import RevisionDetail from './app/revisions/components/revisionDetails/RevisionDetail';
import Findings from './app/revisions/components/findings/Findings';
import FindingDetails from './app/revisions/components/findingsDetails/FindingDetails';
import AddRevisionForm from './app/revisions/components/revisionsForm/AddRevisionForm';
import ForgotPassword from './app/login/ForgotPassword';
import ResetPassword from './app/login/ResetPassword';
import AddFindingsForm from "./app/revisions/components/findingsForm/AddFindingsForm";
import RevisionReports from './app/reports/RevisionReports';
import UserManual from "./app/userManual/UserManual";
import Codebook from "./app/administration/Codebook/Codebook";


function App() {
  const existingTokens = localStorage.getItem('jwt-token-risk');
  const [authTokens, setAuthTokens] = useState(existingTokens);
  const lang = getLanguage();
  let history = useHistory();

  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState([]);
  const [userDepartmentsData, setUserDepartmentsData] = useState([]);
  const setTokens = (token) => {
    localStorage.setItem('jwt-token-risk', token);
    setAuthTokens(token);
  };

  function logout() {
    localStorage.removeItem('jwt-token-risk');
    localStorage.removeItem('webSocket_token_risk');
    localStorage.removeItem('language_risk');
    localStorage.removeItem('activeFilters');
    localStorage.removeItem('activeFiltersIncurred');
    localStorage.removeItem('activeFiltersCourt');
    localStorage.removeItem('departmentFilters');
    localStorage.removeItem('previous_link');
    //window.location('/login');
    history.push('/login');
  }

  useEffect(() => {
    if (localStorage.getItem('jwt-token-risk')) {
      const fetchData = async () => {
        try {
          const {data} = await getCurrentUser();
          setUserData(data);
        } catch (err) {
          if (err.response?.status === 401) {
            logout();
            setLoading(false);
          }
          logout();
          setLoading(false);
        }
      };
      fetchData().then((response) => {
        const fetchLoggedUserDepartments = async () => {
          try {
            const {data} = await getDepartmentsCurrentUser();
            setUserDepartmentsData(data);
            setLoading(false);
          } catch (err) {
            setLoading(false);
          }
        };
        fetchLoggedUserDepartments();
      });
    } else {
      setLoading(false);
    }
  }, []);
  const getUserConfirmation = (dialogKey, callback) => {
    // use "message" as Symbol-based key
    const dialogTrigger = window[Symbol.for(dialogKey)];

    if (dialogTrigger) {
      // pass the callback to delegate
      // to the invoked dialog
      return dialogTrigger(callback);
    }

    // Fallback to allowing navigation
    callback(true);
  };

  return (
    <>
      {loading ? (
        <Spin spinning={loading} size={'large'} className="spinner" />
      ) : (
        <UserContext.Provider value={userData}>
          <DepartmentContext.Provider value={userDepartmentsData}>
            <AuthContext.Provider
              value={{authTokens, setAuthTokens: setTokens}}
            >
              <div className="App">
                <Router getUserConfirmation={getUserConfirmation}>
                  <Switch>
                    <PrivateRoute
                      path="/dashboard"
                      exact
                      component={Dashboard}
                      pageTitle="dashboard"
                    />
                    <PrivateRoute
                      path="/users"
                      exact
                      component={Users}
                      pageTitle="users"
                      authorisedRoles={[
                        roles.role_admin,
                        roles.role_super_admin,
                      ]}
                    />
                    <PrivateRoute
                        path="/app-details"
                        exact
                        component={UserManual}
                        pageTitle="appDetails"
                    />
                    <PrivateRoute
                      path="/key-risk-indicators"
                      exact
                      component={KeyRiskIndicators}
                      pageTitle="keyRiskIndicators"
                      authorisedRoles={[
                        roles.role_risk_sector,
                        roles.role_user_in_charge,
                        roles.role_responsible_user,
                        roles.role_super_admin,
                      ]}
                    />
                    <PrivateRoute
                      path="/key-risk-indicators/add"
                      exact
                      component={AddKeyRiskIndicator}
                      pageTitle="addKeyRiskIndicator"
                      authorisedRoles={[
                        roles.role_risk_sector,
                        roles.role_super_admin,
                      ]}
                    />
                    <PrivateRoute
                      path="/key-risk-indicators/:id"
                      exact
                      component={ViewKeyRiskIndicator}
                      pageTitle="singleKeyRiskIndicator"
                      authorisedRoles={[
                        roles.role_risk_sector,
                        roles.role_user_in_charge,
                        roles.role_responsible_user,
                        roles.role_super_admin,
                      ]}
                    />
                    <PrivateRoute
                      path="/key-risk-indicators/:id/edit"
                      exact
                      component={ViewKeyRiskIndicator}
                      pageTitle="singleKeyRiskIndicator"
                      authorisedRoles={[
                        roles.role_risk_sector,
                        roles.role_user_in_charge,
                        roles.role_responsible_user,
                        roles.role_super_admin,
                      ]}
                    />
                    <PrivateRoute
                      path="/risk-mitigation"
                      exact
                      component={MitigationRisk}
                      pageTitle="mitigationRisk"
                      authorisedRoles={[
                        roles.role_technological,
                        roles.role_super_admin,
                      ]}
                    />
                    <PrivateRoute
                      path="/business-lines"
                      exact
                      component={BusinessLines}
                      pageTitle="businessLines"
                      authorisedRoles={[
                        roles.role_technological,
                        roles.role_super_admin,
                      ]}
                    />
                    <PrivateRoute
                      path="/type-gain-losses"
                      exact
                      component={TypeGainLoss}
                      pageTitle="typeGainLoss"
                      authorisedRoles={[
                        roles.role_technological,
                        roles.role_super_admin,
                      ]}
                    />
                    <PrivateRoute
                      path="/incurred-risk/add"
                      exact
                      component={AddIncurredRisk}
                      pageTitle="incurred-risk"
                      authorisedRoles={[
                        roles.role_user_in_charge,
                        roles.role_super_admin,
                      ]}
                    />
                    <PrivateRoute
                      path="/incurred-risk/:id"
                      exact
                      component={RiskComponents}
                      pageTitle="incurred-risk"
                      authorisedRoles={[
                        roles.role_super_admin,
                        roles.role_risk_sector,
                        roles.role_responsible_user,
                        roles.role_user_in_charge,
                      ]}
                    />
                    <PrivateRoute
                      path="/incurred-risk/:id/edit"
                      exact
                      component={RiskComponents}
                      pageTitle="incurred-risk"
                      authorisedRoles={[
                        roles.role_super_admin,
                        roles.role_risk_sector,
                        roles.role_responsible_user,
                        roles.role_user_in_charge,
                      ]}
                    />
                    <PrivateRoute
                      path="/methodologies"
                      exact
                      component={Metodologies}
                      pageTitle="metodologies"
                      authorisedRoles={[
                        roles.role_technological,
                        roles.role_super_admin,
                      ]}
                    />
                    <PrivateRoute
                        path="/codebook"
                        exact
                        component={Codebook}
                        pageTitle="codebooks"
                        authorisedRoles={[
                          roles.role_technological,
                          roles.role_super_admin,
                        ]}
                    />
                    <PrivateRoute
                      path="/methodologies"
                      exact
                      component={Metodologies}
                      pageTitle="metodologies"
                      authorisedRoles={[
                        roles.role_technological,
                        roles.role_super_admin,
                      ]}
                    />
                    <PrivateRoute
                      path="/departments"
                      exact
                      component={Departments}
                      pageTitle="departments"
                      authorisedRoles={[
                        roles.role_technological,
                        roles.role_super_admin,
                        roles.role_admin,
                      ]}
                    />
                    <PrivateRoute
                      path="/cost-estimations"
                      exact
                      component={CostEstimations}
                      pageTitle="costEstimations"
                      authorisedRoles={[
                        roles.role_technological,
                        roles.role_super_admin,
                      ]}
                    />
                    <PrivateRoute
                      path="/risk-categories"
                      exact
                      component={RiskCategories}
                      pageTitle="riskCategories"
                      authorisedRoles={[
                        roles.role_technological,
                        roles.role_super_admin,
                      ]}
                    />

                    <PrivateRoute
                      path="/potential-risk-types"
                      exact
                      component={PotentialRiskTypes}
                      pageTitle="potentialRiskTypes"
                      authorisedRoles={[
                        roles.role_technological,
                        roles.role_super_admin,
                      ]}
                    />
                    <PrivateRoute
                      path="/risk-causes"
                      exact
                      component={RiskCauses}
                      pageTitle="riskCauses"
                      authorisedRoles={[
                        roles.role_technological,
                        roles.role_super_admin,
                      ]}
                    />

                    <PrivateRoute
                      path="/department-types"
                      exact
                      component={DepartmentType}
                      pageTitle="departmentType"
                      authorisedRoles={[
                        roles.role_technological,
                        roles.role_super_admin,
                      ]}
                    />
                    <PrivateRoute
                      path="/financial-performances"
                      exact
                      component={FinancialPerformances}
                      pageTitle="financialPerformances"
                      authorisedRoles={[
                        roles.role_technological,
                        roles.role_super_admin,
                      ]}
                    />
                    <PrivateRoute
                      path="/subprocesses"
                      exact
                      component={Subprocesses}
                      pageTitle="subprocesses"
                      authorisedRoles={[
                        roles.role_technological,
                        roles.role_super_admin,
                      ]}
                    />
                    <PrivateRoute
                      path="/court-subcategory-risks"
                      exact
                      component={CourtSubcategoryRisks}
                      pageTitle="courtSubcategoryRisks"
                      authorisedRoles={[
                        roles.role_technological,
                        roles.role_super_admin,
                      ]}
                    />
                    <PrivateRoute
                      path="/processes"
                      exact
                      component={Processes}
                      pageTitle="processes"
                      authorisedRoles={[
                        roles.role_technological,
                        roles.role_super_admin,
                      ]}
                    />
                    <PrivateRoute
                      path="/frequency-occurence-risks"
                      exact
                      component={FrequencyOccurenceRisks}
                      pageTitle="frequencyOccurenceRisks"
                      authorisedRoles={[
                        roles.role_technological,
                        roles.role_super_admin,
                      ]}
                    />
                    <PrivateRoute
                      path="/court-category-risks"
                      exact
                      component={CourtCategoryRisks}
                      pageTitle="courtCategoryRisks"
                      authorisedRoles={[
                        roles.role_technological,
                        roles.role_super_admin,
                      ]}
                    />
                    <PrivateRoute
                      path="/entered-risks"
                      exact
                      component={EnteredRisks}
                      pageTitle="risk-entered"
                      authorisedRoles={[
                        roles.role_super_admin,
                        roles.role_risk_sector,
                        roles.role_responsible_user,
                        roles.role_user_in_charge,
                      ]}
                    />
                    <PrivateRoute
                      path="/verified-risks"
                      exact
                      component={VerifiedRisks}
                      pageTitle="risk-verified"
                      authorisedRoles={[
                        roles.role_super_admin,
                        roles.role_risk_sector,
                        roles.role_responsible_user,
                        roles.role_user_in_charge,
                      ]}
                    />
                    <PrivateRoute
                      path="/during-risks"
                      exact
                      component={DuringRisks}
                      pageTitle="risk-during"
                      authorisedRoles={[
                        roles.role_super_admin,
                        roles.role_risk_sector,
                        roles.role_responsible_user,
                        roles.role_user_in_charge,
                      ]}
                    />
                    <PrivateRoute
                      path="/closed-risks"
                      exact
                      component={ClosedRisks}
                      pageTitle="risk-closed"
                      authorisedRoles={[
                        roles.role_super_admin,
                        roles.role_risk_sector,
                        roles.role_responsible_user,
                        roles.role_user_in_charge,
                      ]}
                    />
                    <PrivateRoute
                      path="/rejected-risks"
                      exact
                      component={RejectedRisks}
                      pageTitle="risk-rejected"
                      authorisedRoles={[
                        roles.role_super_admin,
                        roles.role_risk_sector,
                        roles.role_responsible_user,
                        roles.role_user_in_charge,
                      ]}
                    />
                    <PrivateRoute
                      path="/risks"
                      exact
                      component={Risks}
                      pageTitle="risk-considerations"
                      authorisedRoles={[
                        roles.role_super_admin,
                        roles.role_risk_sector,
                        roles.role_responsible_user,
                        roles.role_user_in_charge,
                      ]}
                    />

                    <PrivateRoute
                      path="/reports/key-indicators/key-indicator-report"
                      exact
                      component={KriReport}
                      pageTitle="kriReport"
                    />
                    <PrivateRoute
                      path="/potential-risk/add"
                      exact
                      component={AddPotentialRisk}
                      pageTitle="potencialRisk"
                      authorisedRoles={[
                        roles.role_user_in_charge,
                        roles.role_super_admin,
                      ]}
                    />
                    <PrivateRoute
                      path="/potential-risk/:id"
                      exact
                      component={RiskComponents}
                      pageTitle="potencialRisk"
                      authorisedRoles={[
                        roles.role_super_admin,
                        roles.role_risk_sector,
                        roles.role_responsible_user,
                        roles.role_user_in_charge,
                      ]}
                    />
                    <PrivateRoute
                      path="/potential-risk/:id/edit"
                      exact
                      component={RiskComponents}
                      pageTitle="potencialRisk"
                      authorisedRoles={[
                        roles.role_super_admin,
                        roles.role_risk_sector,
                        roles.role_responsible_user,
                        roles.role_user_in_charge,
                      ]}
                    />
                    <PrivateRoute
                      path="/court-risk/add"
                      exact
                      component={AddLitigation}
                      pageTitle="litigation"
                      authorisedRoles={[
                        roles.role_user_in_charge,
                        roles.role_super_admin,
                      ]}
                    />
                    <PrivateRoute
                      path="/court-risk/:id"
                      exact
                      component={RiskComponents}
                      pageTitle="litigation"
                      authorisedRoles={[
                        roles.role_super_admin,
                        roles.role_risk_sector,
                        roles.role_responsible_user,
                        roles.role_user_in_charge,
                      ]}
                    />
                    <PrivateRoute
                      path="/court-risk/:id/edit"
                      exact
                      component={RiskComponents}
                      pageTitle="litigation"
                      authorisedRoles={[
                        roles.role_super_admin,
                        roles.role_risk_sector,
                        roles.role_responsible_user,
                        roles.role_user_in_charge,
                      ]}
                    />
                    <PrivateRoute
                      path="/reports/kri-report"
                      exact
                      component={KriReport2}
                      pageTitle="kriReport"
                    />
                    <PrivateRoute
                      path="/reports/kri-report-by-date"
                      exact
                      component={KriReport}
                      pageTitle="kriReport2"
                    />
                    <PrivateRoute
                      path="/reports/occurred-risk-report"
                      exact
                      component={OccurredRiskReport}
                      pageTitle="occurredRiskReport"
                    />
                    <PrivateRoute
                      path="/reports/risk-loss-report"
                      exact
                      component={RiskLossReport}
                      pageTitle="riskLossReport"
                    />
                    <PrivateRoute
                      path="/reports/revisions-report"
                      exact
                      component={RevisionReports}
                      pageTitle="revisionsReport"
                    />
                    <PrivateRoute
                      path="/reports/measures-report"
                      exact
                      component={Measures}
                      pageTitle="measures"
                    />
                    <PrivateRoute
                      path="/reports/litigation-report"
                      exact
                      component={LitigationReport}
                      pageTitle="litigation"
                    />
                    <PrivateRoute
                      path="/reports/new-process-risk-report"
                      exact
                      component={ORNewProductsProcesses}
                      pageTitle="oRNewProductsProcesses"
                    />
                    <PrivateRoute
                      path="/reports/third-parties-risk-report"
                      exact
                      component={ThirdPartiesReport}
                      pageTitle="thirdPartiesReport"
                    />
                    <PrivateRoute
                      path="/risk-sub-causes"
                      exact
                      component={SubRisksCauses}
                      pageTitle="subRisksCauses"
                      authorisedRoles={[
                        roles.role_technological,
                        roles.role_super_admin,
                      ]}
                    />
                    <PrivateRoute
                      path="/deleted-risks"
                      exact
                      component={DeletedRisks}
                      pageTitle="risk-deleted"
                      authorisedRoles={[
                        roles.role_super_admin,
                        roles.role_risk_sector,
                      ]}
                    />
                    <PrivateRoute
                      path="/reports/report-log"
                      exact
                      component={ReportLog}
                      pageTitle="report-log"
                      authorisedRoles={[
                        roles.role_super_admin,
                        roles.role_risk_sector,
                      ]}
                    />
                    <PrivateRoute
                      path="/revisions"
                      exact
                      component={Revisions}
                      pageTitle="revisions"
                      authorisedRoles={[
                        roles.role_super_admin,
                        roles.role_admin,
                        roles.role_internal_auditor,
                        roles.role_head_of_internal_audit,
                        roles.role_internal_audit_responsible,
                        roles.role_sector_director,
                      ]}
                    />
                    <PrivateRoute
                      path="/revisions/add"
                      exact
                      component={AddRevisionForm}
                      pageTitle="RevisionAdd"
                      authorisedRoles={[
                        roles.role_super_admin,
                        roles.role_admin,
                        roles.role_internal_auditor,
                        roles.role_head_of_internal_audit,
                      ]}
                    />
                    <PrivateRoute
                      path="/revisions/:id"
                      exact
                      component={RevisionDetail}
                      pageTitle="RevisionDetail"
                      authorisedRoles={[
                        roles.role_super_admin,
                        roles.role_admin,
                        roles.role_internal_auditor,
                        roles.role_head_of_internal_audit,
                        roles.role_internal_audit_responsible,
                        roles.role_sector_director,
                      ]}
                    />

                    <PrivateRoute
                      path="/revisions/:id/findings"
                      exact
                      component={Findings}
                      pageTitle="revisionsFindings"
                      authorisedRoles={[
                        roles.role_super_admin,
                        roles.role_admin,
                        roles.role_internal_auditor,
                        roles.role_head_of_internal_audit,
                        roles.role_internal_audit_responsible,
                        roles.role_sector_director,
                      ]}
                    />
                    <PrivateRoute
                        path="/revisions/:id/findings/add"
                        exact
                        component={AddFindingsForm}
                        pageTitle="revisionsFindings"
                        authorisedRoles={[
                          roles.role_super_admin,
                          roles.role_admin,
                          roles.role_internal_auditor,
                          roles.role_head_of_internal_audit,
                        ]}
                    />
                    <PrivateRoute
                      path="/revisions/:revisionId/findings/:findingId"
                      exact
                      component={FindingDetails}
                      pageTitle="findingDetails"
                      authorisedRoles={[
                        roles.role_super_admin,
                        roles.role_admin,
                        roles.role_internal_auditor,
                        roles.role_head_of_internal_audit,
                        roles.role_internal_audit_responsible,
                        roles.role_sector_director,
                      ]}
                    />

                    <PrivateRoute
                        path="/revision-types"
                        exact
                        component={RevisionType}
                        pageTitle="revisionTypes"
                        authorisedRoles={[
                          roles.role_admin,
                          roles.role_super_admin,
                          roles.role_head_of_internal_audit
                        ]}
                    />
                    <PrivateRoute
                        path="/revision-scope"
                        exact
                        component={RevisionScope}
                        pageTitle="revisionScope"
                        authorisedRoles={[
                          roles.role_admin,
                          roles.role_super_admin,
                          roles.role_head_of_internal_audit
                        ]}
                    />
                    <Route path="/login" component={Login} />
                    <Route path="/forgot-password" component={ForgotPassword} />
                    <Route path="/account/reset/finish" component={ResetPassword} />
                    <Route path="/not-found" component={ErrorPage404} />
                    <Route path="/403" exact component={ErrorPage403} />
                    <Redirect from="/" exact to="/dashboard" />
                    <Redirect to="/not-found" />
                  </Switch>
                </Router>
              </div>
            </AuthContext.Provider>
          </DepartmentContext.Provider>
        </UserContext.Provider>
      )}
    </>
  );
}

export default App;
